import { createFileRoute } from '@tanstack/react-router';
import { WarehouseLandingRouteView } from '@/pages/workspaces/integrations/warehouse/routing';
import { LastWorkspaceResolver } from './-components';

function WarehouseRedshiftRoute() {
  // No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the
  // resolver rebuilds the target from the bundle prefix — which would find no `/journeys/` here,
  // drop the sub-path, and land on the Journeys home instead of this page.
  return (
    <LastWorkspaceResolver>
      <WarehouseLandingRouteView connector="redshift" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift')({
  component: WarehouseRedshiftRoute,
});
